export const FONT_SIZE_SMALL = 16;